var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home-cosmetics-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Inventory",
    transform: "translate(-40.000000, -570.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-Manual-Card-Copy-6",
    transform: "translate(16.000000, 546.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-cosmetics-icon",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C31.1045695,0 32,0.8954305 32,2 L32,18 C32,19.1045695 31.1045695,20 30,20 L21.3333333,20 C20.2287638,20 19.3333333,20.8954305 19.3333333,22 L19.3333333,30 C19.3333333,31.1045695 18.4379028,32 17.3333333,32 L14.6666667,32 C13.5620972,32 12.6666667,31.1045695 12.6666667,30 L12.6666667,22 C12.6666667,20.8954305 11.7712362,20 10.6666667,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,2 C0,0.8954305 0.8954305,0 2,0 L30,0 Z M2,16 L2,18 L10.6666667,18 C12.8088621,18 14.5577455,19.6839685 14.6617714,21.8003597 L14.6666667,22 L14.6666667,30 L17.3333333,30 L17.3333333,22 C17.3333333,19.8578046 19.0173018,18.1089211 21.133693,18.0048953 L21.3333333,18 L30,18 L30,16 L2,16 Z M2,14 L30,14 L30,2 L26,2 L26,11 C26,11.5522847 25.5522847,12 25,12 C24.4477153,12 24,11.5522847 24,11 L24,2 L19,2 L19,6 C19,6.55228475 18.5522847,7 18,7 C17.4477153,7 17,6.55228475 17,6 L17,2 L12,2 L12,9 C12,9.55228475 11.5522847,10 11,10 C10.4477153,10 10,9.55228475 10,9 L10,2 L2,2 L2,14 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBrush);
export default __webpack_public_path__ + "static/media/paint-brush.cf8711dd6b3eeeb30e4479fd312f7a05.svg";
export { ForwardRef as ReactComponent };